import { TrendingDown, TrendingUp } from "lucide-react";
import { cents, endsIn } from "./utils";
import { RiskMeter, riskFromPrice } from "./Risk";

const Move = ({ v }) => {
  if (v == null || Math.abs(v) < 0.01) return null;
  const up = v > 0;
  const I = up ? TrendingUp : TrendingDown;
  return <span className={`inline-flex items-center gap-0.5 ${up ? "text-emerald-300" : "text-red-300"}`}><I className="w-3 h-3" />{(v * 100).toFixed(0)}pt</span>;
};

export const MarketRow = ({ m, onOpen }) => (
  <button onClick={() => onOpen(m.slug)} data-testid={`pm-row-${m.slug}`}
    className="w-full text-left flex items-center gap-3 px-3 sm:px-4 py-3 hover:bg-white/[0.03] transition-colors">
    {m.image ? <img src={m.image} alt="" className="w-9 h-9 rounded-lg object-contain bg-white/5 shrink-0" /> :
      <div className="w-9 h-9 rounded-lg bg-white/5 shrink-0" />}
    <div className="flex-1 min-w-0">
      <div className="text-sm font-semibold line-clamp-2">{m.label}</div>
      <div className="text-[11px] text-slate-500 font-num flex gap-2 mt-0.5 flex-wrap">
        <span className="uppercase tracking-wider">{m.group}</span>
        <span>ends {endsIn(m)}</span>
        {m.spread != null && <span>spread {cents(m.spread)}</span>}
        <Move v={m.move_1h} />
        {m.mid != null && <RiskMeter level={riskFromPrice(Math.max(m.mid, 1 - m.mid))} compact testid={`risk-${m.slug}`} />}
      </div>
    </div>
    <div className="flex flex-col gap-1 shrink-0 w-28">
      <span className="flex justify-between gap-1 rounded-md bg-emerald-500/10 text-emerald-200 px-2 py-0.5 text-[11px] font-num">
        <span className="truncate">{m.yes_name}</span><b>{cents(m.mid)}</b></span>
      <span className="flex justify-between gap-1 rounded-md bg-red-500/10 text-red-200 px-2 py-0.5 text-[11px] font-num">
        <span className="truncate">{m.no_name}</span><b>{m.mid == null ? "—" : cents(1 - m.mid)}</b></span>
    </div>
  </button>
);
